import React from "react";

import {
  InputTypeCalculateForm,
  InputTypeDistributeForm,
  InputTypeFreeTextForm,
  InputTypeSelectForm,
  InputTypeHistoricalForm
} from "@/Components/Questions/InputTypes/Report";

const Components = {
  calculate: InputTypeCalculateForm,
  select: InputTypeSelectForm,
  free_text: InputTypeFreeTextForm,
  distribute: InputTypeDistributeForm,
  historical: InputTypeHistoricalForm
};

export const DynamicInputType = ({ question, values = null }) => {
  if (typeof Components[question.type.enum] !== "undefined") {
    return React.createElement(Components[question.type.enum], {
      key: `dynamic_input_type_${question.id}`,
      question,
      values
    });
  }

  return React.createElement(
    () => <div>The component {question.type.enum} has not been created yet.</div>,
    { key: `dynamic_input_type_${question.id}` }
  );
}
